module.exports = __webpack_public_path__ + "img/header-engagementRings070Carat.9878cf8.webp";